import { render, staticRenderFns } from "./assistant-dialog.vue?vue&type=template&id=2b1a05dd&"
import script from "./assistant-dialog.vue?vue&type=script&lang=js&"
export * from "./assistant-dialog.vue?vue&type=script&lang=js&"
import style0 from "./assistant-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b1a05dd')) {
      api.createRecord('2b1a05dd', component.options)
    } else {
      api.reload('2b1a05dd', component.options)
    }
    module.hot.accept("./assistant-dialog.vue?vue&type=template&id=2b1a05dd&", function () {
      api.rerender('2b1a05dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/my/components/assistant-dialog.vue"
export default component.exports